import { useEffect } from "react";
import { Link } from "react-router-dom";

interface ArticleLayoutProps {
  title: string;
  subtitle: string;
  image: string;
  date: string;
  keywords: string;
  children: React.ReactNode;
}

export default function ArticleLayout({ title, subtitle, image, date, keywords, children }: ArticleLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <article className="pt-24 pb-16 md:pb-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
          <span className="text-foreground-400">Article</span>
        </nav>

        <div className="mb-10">
          <div className="flex items-center gap-3 mb-5">
            <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">Guide</span>
            <span className="text-xs text-foreground-400">{date}</span>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-[1.15] mb-5">{title}</h1>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed">{subtitle}</p>
        </div>

        <div className="rounded-2xl overflow-hidden mb-12">
          <img src={image} alt={title} className="w-full h-64 md:h-80 object-cover" />
        </div>

        <div className="text-foreground-800 leading-relaxed">
          {children}
        </div>
      </div>
    </article>
  );
}